/** Иконка навигации каталога из локальных SVG-файлов. */
import archive from "./catalog-icons/archive.svg";
import armchair from "./catalog-icons/armchair.svg";
import baby from "./catalog-icons/baby.svg";
import bath from "./catalog-icons/bath.svg";
import bed from "./catalog-icons/bed.svg";
import box from "./catalog-icons/box.svg";
import brick from "./catalog-icons/brick.svg";
import bulb from "./catalog-icons/bulb.svg";
import cable from "./catalog-icons/cable.svg";
import ceiling from "./catalog-icons/ceiling.svg";
import door from "./catalog-icons/door.svg";
import droplet from "./catalog-icons/droplet.svg";
import dumbbell from "./catalog-icons/dumbbell.svg";
import faucet from "./catalog-icons/faucet.svg";
import film from "./catalog-icons/film.svg";
import frame from "./catalog-icons/frame.svg";
import guitar from "./catalog-icons/guitar.svg";
import kitchen from "./catalog-icons/kitchen.svg";
import lamp from "./catalog-icons/lamp.svg";
import monitor from "./catalog-icons/monitor.svg";
import paw from "./catalog-icons/paw.svg";
import picture from "./catalog-icons/picture.svg";
import pipe from "./catalog-icons/pipe.svg";
import plant from "./catalog-icons/plant.svg";
import roller from "./catalog-icons/roller.svg";
import ruler from "./catalog-icons/ruler.svg";
import rug from "./catalog-icons/rug.svg";
import socket from "./catalog-icons/socket.svg";
import sofa from "./catalog-icons/sofa.svg";
import switchIcon from "./catalog-icons/switch.svg";
import tile from "./catalog-icons/tile.svg";
import tv from "./catalog-icons/tv.svg";
import wardrobe from "./catalog-icons/wardrobe.svg";
import window from "./catalog-icons/window.svg";

export type CatalogNavIconName =
	| "archive"
	| "armchair"
	| "baby"
	| "bath"
	| "bed"
	| "box"
	| "brick"
	| "bulb"
	| "cable"
	| "ceiling"
	| "door"
	| "droplet"
	| "dumbbell"
	| "faucet"
	| "film"
	| "frame"
	| "guitar"
	| "kitchen"
	| "lamp"
	| "monitor"
	| "paw"
	| "picture"
	| "pipe"
	| "plant"
	| "roller"
	| "ruler"
	| "rug"
	| "socket"
	| "sofa"
	| "switch"
	| "tile"
	| "tv"
	| "wardrobe"
	| "window";

const ICONS: Record<CatalogNavIconName, string> = {
	archive,
	armchair,
	baby,
	bath,
	bed,
	box,
	brick,
	bulb,
	cable,
	ceiling,
	door,
	droplet,
	dumbbell,
	faucet,
	film,
	frame,
	guitar,
	kitchen,
	lamp,
	monitor,
	paw,
	picture,
	pipe,
	plant,
	roller,
	ruler,
	rug,
	socket,
	sofa,
	switch: switchIcon,
	tile,
	tv,
	wardrobe,
	window,
};

export const CatalogNavIcon = ({
	name,
	size = 16,
}: {
	name: CatalogNavIconName;
	size?: number;
}) => (
	<div
		aria-hidden="true"
		className="shrink-0 bg-current"
		style={{
			width: size,
			height: size,
			mask: `url(${ICONS[name]}) center / contain no-repeat`,
			WebkitMask: `url(${ICONS[name]}) center / contain no-repeat`,
		}}
	/>
);
